import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { navigationPath } from '../App';
import SpinningLoader from '../components/spinning-loader';
import { Settings } from 'lucide-react';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      setIsLoading(true);

      if (!username) throw new Error('Harap masukkan username.');
      if (!password) throw new Error('Harap masukkan password.');

      const response = await fetch(`/api/cms/login`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const res = await response.json();
      if (!response.ok) throw new Error(res.message);
      localStorage.setItem('accessToken', res.data);

      setIsLoading(false);

      navigate(navigationPath.dashboard);
    } catch (error: any) {
      setIsLoading(false);
      alert(error.message || `Terjadi kesalahan ketika login.`);
    }
  };

  return (
    <div className='min-h-screen flex items-center justify-center relative overflow-hidden bg-[#0f172a]'>
      {/* Background elements */}
      <div className='absolute inset-0 z-0'>
        {/* Gradient backdrop */}
        <div className='absolute inset-0 bg-gradient-to-br from-[#141c2f] to-[#0f1423]'></div>

        {/* Animated floating shapes */}
        <div className='absolute top-0 left-0 w-full h-full overflow-hidden opacity-20'>
          {/* Large circle */}
          <div className='absolute top-1/4 -left-24 w-96 h-96 bg-[#4269ed] rounded-full opacity-10 animate-pulse'></div>

          {/* Small circles */}
          <div className='absolute top-3/4 right-10 w-32 h-32 bg-blue-400 rounded-full opacity-20'></div>
          <div className='absolute bottom-10 left-1/4 w-64 h-64 bg-indigo-500 rounded-full opacity-10'></div>

          {/* Blurred rectangles */}
          <div className='absolute top-20 right-1/4 w-80 h-40 bg-[#4269ed] opacity-5 rotate-12 rounded-2xl blur-2xl'></div>
          <div className='absolute top-1/2 -right-20 w-80 h-80 bg-blue-600 opacity-5 -rotate-12 rounded-2xl blur-2xl'></div>

          {/* Grid pattern */}
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMyMTJhNDAiIGZpbGwtb3BhY2l0eT0iMC4wNCI+PHBhdGggZD0iTTM2IDM0djFoLTJ2MWgydjFoLTN2MWgzdjFoLTJ2MWgydjFoLTJWMzRoMnpNMzEgMzR2M2gtMXYtMWgtMXYyaC0xdi0xaC0xdjJoLTF2LTVoNXpNMzMgMzR2NWgtNXYtNWg1eiIvPjwvZz48L2c+PC9zdmc+')] opacity-30"></div>
        </div>
      </div>

      {/* Main content */}
      {isLoading ? (
        <div className='flex flex-col items-center justify-center z-10'>
          <SpinningLoader size='large' color='primary' />
          <p className='mt-4 text-white'>Authenticating...</p>
        </div>
      ) : (
        <div className='w-full max-w-md p-8 rounded-xl bg-[#1c243b]/90 backdrop-blur-sm shadow-2xl border border-[#2a334a]/50 z-10'>
          <div className='flex flex-col items-center justify-center mb-8'>
            <div className='flex items-center justify-center w-20 h-20 mb-4 rounded-full bg-[#212a40] text-[#4269ed] shadow-lg'>
              <Settings size={36} />
            </div>
            <h1 className='text-2xl font-bold text-white'>APP ANTI NAWALA CMS</h1>
            <p className='mt-2 text-gray-400'>Silahkan masuk untuk melanjutkan</p>
          </div>

          <form onSubmit={handleSubmit} className='space-y-6'>
            <div>
              <label htmlFor='username' className='block text-sm font-medium text-blue-400 mb-2'>
                Username
              </label>
              <input
                required
                type='text'
                id='username'
                name='username'
                placeholder='Masukkan username'
                value={username}
                onChange={e => setUsername(e.target.value)}
                className='w-full h-[45px] bg-[#212a40] text-white border border-gray-600 rounded-md px-4 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors'
              />
            </div>

            <div>
              <label htmlFor='password' className='block text-sm font-medium text-blue-400 mb-2'>
                Password
              </label>
              <input
                required
                type='password'
                id='password'
                name='password'
                placeholder='Masukkan password'
                value={password}
                onChange={e => setPassword(e.target.value)}
                className='w-full h-[45px] bg-[#212a40] text-white border border-gray-600 rounded-md px-4 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors'
              />
            </div>

            <div>
              <button
                type='submit'
                className='w-full py-3 px-4 bg-[#4269ed] hover:bg-[#3258dc] text-white font-medium rounded-md shadow-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-offset-[#1c243b]'
              >
                Masuk
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Login;
